
import React, { useState, useEffect } from 'react';
import CommonLoader from '../../common/CommonLoader';
import ClientTable from './ClientTable';
import { GetClients } from '../../../services/ClientsMaintenanceService';
import { NotificationManager } from 'react-notifications';

const Clients = () => {
  const [loading, setLoading] = useState(false);
  const [clientsData, setClientsData] = useState([]);
  const [clientsCount, setClientsCount] = useState(0);
  const [searchText, setSearchText] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getClients();
  }, [page, rowsPerPage, searchText]);

  const getClients = async () => {
    try {
      setLoading(true);
      const response = await GetClients(page, rowsPerPage, searchText);
      setClientsData(response.results);
      setClientsCount(response.count);
    } catch (err) {
      NotificationManager.error('Error getting clients. ' + err, 'Error');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (text) => {
    setPage(0);
    setSearchText(text);
  };

  const onChangePageSettings = async (pageNumber, pageSize) => {
    setPage(pageNumber);
    setRowsPerPage(pageSize);
  };

  return (
    <div className="vlp-component-container">
      <span className="title">Clients </span>
      <hr />
      <ClientTable clientsData={clientsData} count={clientsCount} onChange={onChangePageSettings} onSearch={handleSearch} />
      <CommonLoader loading={loading} />
    </div>
  );
};

export default Clients;

